module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Quote#1-02a86d12acd79f8efe0b692d1f26340f.svg";